export default __webpack_public_path__ + "static/media/property_721.c2c2b699.png";